export const SET_ORIGEM_COLLECTION = 'ORIGEM/SET_ORIGEM_COLLECTION';
